'use strict';

var _ = require('lodash');

var rutils = require('./rhythm-utils');
var at = require('../utils/environment');
var breakpoints = require('../utils/breakpoints');


var OR = rutils.OR;
var pick = rutils.pick;
var repeat = rutils.repeat;


var Rhythmist = {

_maxItemsPerRender: 10,
_maxPickerAttempts: 10,
_totalRenderedItems: 0,
_rhythm: [],

setupRhythm: function() {
    if (at.client) this._clientRhythm();
    else this._rhythm = [ pick(this.postStore) ];
},

_clientRhythm: function() {
    var post = pick(this.postStore);
    var specialAd = pick(this.advertiseStore, 'pickSpecialAd');
    var ad;
    var card;
    var $window = this.dom.$window;

    if ($window && ($window.width() >= breakpoints.MOBILE_TO_DESKTOP)) {
        this._rhythm = [
            repeat(post, 4),
            OR(specialAd, post)
        ];
    }
    else {
        ad = pick(this.advertiseStore);
        card = pick(this.cardStore);
        this._rhythm = [
            repeat(post, 3),
            OR(ad, post),
            OR(specialAd, post),
            post,
            OR(card, post),
            repeat(post, 2),
            OR(ad, post)
        ];
    }
    this._rhythm = _.flatten(this._rhythm);
},

updateTotalRenderedItems: function() {
    this._totalRenderedItems = this.itemStore.all().length;
},

_fromFirstPage: function() {
    return (this._totalRenderedItems === 0);
},

buildPage: function() {
    var hasManyPickers = (this._rhythm.length > 1);
    var info;
    var item;
    var items = [];
    var iteration = this._maxItemsPerRender;
    var picker = this._rhythm[0];
    var totalRenderedPages = this.getPagesData().length;

    while (iteration--) {
        if (hasManyPickers) {
            picker = this._rhythm[0];
            this._rhythm.push(this._rhythm.shift());
            info = {
                index: this._totalRenderedItems + items.length + 1,
                fromFirstPage: this._fromFirstPage(),
                nextPage: this.getInitialPageIndex() + totalRenderedPages + 1
            };
        }
        try {
            item = picker(info);
            if (_.isEmpty(item) === false) items.push(item);
            else throw 'Could not get an valid item';
        }
        catch(error) {
            console.warn(error);
            console.info('Stopping page building. Picker',
                picker.storeName, 'failed at iteration #', iteration, info);
            if (picker.attempts < this._maxPickerAttempts) {
                picker.attempts += 1;
                this._rhythm.unshift(this._rhythm.pop());
            }
            break;
        }
    }

    return items;
}

};

module.exports = Rhythmist;
